import a from "open-props";
import z, { createContext as x, useContext as S } from "react";
function o(n) {
  return n ?? void 0;
}
const c = x({});
function ee() {
  return S(c) ?? {};
}
function ne({
  theme: n,
  children: e
}) {
  return /* @__PURE__ */ z.createElement(c.Provider, { value: n }, e);
}
function f(n) {
  return n.reduce((e, [i, r]) => ({ ...e, [i]: r }), {});
}
const {
  sizeXxs: d,
  sizeXs: v,
  sizeSm: h,
  sizeMd: C,
  sizeLg: b,
  sizeXl: $,
  sizeXxl: l,
  sizeContent1: O,
  sizeContent2: P,
  sizeContent3: g,
  sizeHeader1: y,
  sizeHeader2: D,
  sizeHeader3: T,
  size000: X,
  size00: k,
  size1: H,
  size2: I,
  size3: j,
  size4: w,
  size5: E,
  size6: L,
  size7: M,
  size8: R,
  size9: V,
  size10: G,
  size11: q,
  size12: A,
  size13: B,
  size14: F,
  size15: J
} = a, N = {
  size000: X,
  size00: k,
  size1: H,
  size2: I,
  size3: j,
  size4: w,
  size5: E,
  size6: L,
  size7: M,
  size8: R,
  size9: V,
  size10: G,
  size11: q,
  size12: A,
  size13: B,
  size14: F,
  size15: J
}, Q = {
  sizeXxs: d,
  sizeXs: v,
  sizeSm: h,
  sizeMd: C,
  sizeLg: b,
  sizeXl: $,
  sizeXxl: l,
  sizeContent1: O,
  sizeContent2: P,
  sizeContent3: g,
  sizeHeader1: y,
  sizeHeader2: D,
  sizeHeader3: T
}, U = N, W = Q, u = /^--\D{1}.{0,100}$/;
function m(n) {
  return u.test(n);
}
function Y(n) {
  return [
    "auto",
    "inherit",
    "none",
    "min-content",
    "max-content",
    "fit-content"
  ].includes(n);
}
function p(n) {
  return typeof n != "string" ? !1 : [
    /^[0-9]{0,10000}\.?[0-9]{1,10000}(vmin|vmax|vh|vw|%|ch|ex|em|rem|in|cm|mm|pt|pc|px)$/,
    /^var\(--\D{1}.{0,100}\)$/,
    u
  ].some((e) => e.test(n)) || Y(n);
}
function Z(n, e) {
  const i = n.space ?? U, r = f(
    Object.entries(i).map(([s, t]) => [
      s,
      typeof t == "number" ? `${t}px` : t
    ])
  );
  return o(r[e]);
}
function te(n, e) {
  if (e !== void 0)
    return typeof e == "number" && e >= 0 ? `${e}px` : typeof e == "string" && p(e) ? m(e) ? `var(${e})` : e : o(Z(n, e));
}
function ie(n, e) {
  if (e === void 0)
    return;
  if (typeof e == "number" && e >= 0)
    return `${e}px`;
  if (typeof e == "string" && p(e))
    return m(e) ? `var(${e})` : e;
  const i = n.sizes ?? W, r = f(
    Object.entries(i).map(([s, t]) => [
      s,
      typeof t == "number" ? `${t}px` : t
    ])
  );
  return o(r[e]);
}
export {
  c as ThemeContext,
  ne as ThemeProvider,
  p as checkIsCSSLength,
  te as getSafeGutter,
  ie as getSizeValue,
  Z as getSpacingValue,
  W as sizes,
  U as spacing,
  ee as useTheme
};
